module.exports = __webpack_public_path__ + "static/img/MaxGawn.ad88bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MaxGawn.jpg
// module id = YB+U
// module chunks = 0